import './vendor';
import lazyLoading from './modules/lazyLoading';
import Vivus from '../../node_modules/vivus/dist/vivus.js';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
require('/src/js/vendor/mmenu/jquery.mmenu.all.js')
import Swiper, { Pagination, Autoplay, Navigation, EffectFade, Controller, Mousewheel, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, EffectFade,  Pagination, Controller, Mousewheel, Scrollbar ]);

require('../../node_modules/isotope-layout/dist/isotope.pkgd.js')

$('.catlist').isotope({
	// options...
	itemSelector: '.catlist > li',
	percentPosition: true,
	masonry: {
	  	columnWidth: '.catlist > li'
	}
});



$("#menu").mmenu({
	navbar: {
		title: "Каталог продукции"
	}
});

$('.number__minus').click(function () {
	var $input = $(this).parent().find('input');
	var count = parseInt($input.val()) - 1;
	count = count < 1 ? 1 : count;
	$input.val(count);
	$input.change();
	return false;
});
$('.number__plus').click(function () {
	var $input = $(this).parent().find('input');
	$input.val(parseInt($input.val()) + 1);
	$input.change();
	return false;
});


$("#msOrder").change(function() {

	if ($('#delivery_2').prop("checked")) {
	   $('#adress-form').show(300);
	 } else {
	   $('#adress-form').hide(300);
	 }
});



const marquee = new Swiper('.marquee', { 
	loop: true,
   slidesPerView: "auto",
      // centeredSlides: true,
   spaceBetween: 32,
	speed: 20000,
	// grabCursor: true,
	// rewind: true,
	autoplay: {
		delay: 0
	},
        breakpoints: {
            1920: {
                slidesPerView: "auto",
            },
            1028: {
                slidesPerView: "auto",
            },
            576: {
                slidesPerView: "auto",
            },
	    320: {
                slidesPerView: "auto",
            }
        }
});


$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
	disableOn: 700,
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,

	fixedContentPos: false
});



lazyLoading.init();



if(document.querySelector(".btn--modal")) {
	let btnModal = document.querySelectorAll('.btn--modal');
	btnModal.forEach(element => element.addEventListener('click', replaceTitleModal));

	function replaceTitleModal() {
		let modalForm = document.querySelector('#oneclick');
		let title = modalForm.querySelector('.form__title');
		let theme = modalForm.querySelector('.form__theme');
		title.innerHTML = this.dataset.title;
		theme.value = this.dataset.title;
	}
}

    



$('.company-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	appendDots: $('.slick-dots-custom'),
	prevArrow: $("#company-slider-prev"),
	nextArrow: $("#company-slider-next")
});

/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade mfp-img-mobile',
	tClose: 'Закрыть окно (Esc)', 
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".popup-form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		$.magnificPopup.close();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			
			th.trigger("reset");
		}, 3000);
	});
	return false;
});

if(document.querySelector(".requisites__print")) {
	document.querySelector(".requisites__print").addEventListener("click", () => {
		window.print()
	})
}


$(".product-tabsblock__tabcontent").not(":first").hide();
$(".product-tabsblock__tab").click(function() {
	$(".product-tabsblock__tab").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".product-tabsblock__tabcontent").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");

$("#go-tab-description").click(function() {
	$(".product-tabsblock__tab").removeClass("is-active");
	$("#desc-tab").addClass("is-active");
	$(".product-tabsblock__tabcontent").hide();
	$("#product-descriptions").show();
	$('html, body').animate({
		scrollTop: $('#product-descriptions').offset().top - 250
	}, 'slow');
});


$('.productslider-slider').on('setPosition', function () {	
	$(this).find('.productslider-slider__item').height('auto');		      
	var slickTrack = $(this).find('.slick-track');		      
	var slickTrackHeight = $(slickTrack).height();		      
	$(this).find('.productslider-slider__item').css('height', slickTrackHeight + 'px');		      
});	







$(".contacts-tabs__item").not(":first").hide();
$(".contacts-tabs__tab ").click(function() {
	$(".contacts-tabs__tab ").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".contacts-tabs__item").removeClass("is-active").addClass("is-hidden").eq($(this).index()).addClass("is-active").removeClass("is-hidden");
}).eq(0).addClass("is-active");




$('.brands-slider').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 5,
	slidesToScroll: 1,
	arrows: false,
	autoplay: true,
  	autoplaySpeed: 2000,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				vertical: false,
		    }
		},{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				vertical: false,
		    }
		}
	]
});

$('.gallery').on('init', function(event, slick) {
	// Проверка количества слайдов после инициализации
	if (slick.slideCount <= 1) {
	    // Если в .gallery только один слайд
	    $('.gallery').addClass('gallery--one');
	    $('.gallerythumb').hide(); // Скрыть .gallerythumb, если необходимо
	} else {
	    // Если в .gallery больше одного слайда
	    $('.gallerythumb').css('display', 'block');
	}
    }).slick({
	dots: false,
	speed: 1000,
	infinite: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	asNavFor: '.gallerythumb',
    });
    
    $('.gallerythumb').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	vertical: true,
	asNavFor: '.gallery',
	focusOnSelect: true,
	arrows: false,
	responsive: [
	    {
		breakpoint: 576,
		settings: {
		    slidesToShow: 3,
		    slidesToScroll: 1,
		    vertical: false,
		}
	    }
	]
    });
$('.articleslider').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	infinite: false,
	prevArrow: '<button type="button" class="btn-slider prev"><svg><use xlink:href="assets/build/images/sprites.svg#prev"></use></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg><use xlink:href="assets/build/images/sprites.svg#next"></use></svg></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
		    }
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
		    }
		}
	]
});


$( ".productslider" ).each(function(index) {
	$('.productslider-slider', $(this)).slick({
		dots: true,
		speed: 1000,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		appendDots: $('.slick-dots-custom'),
		prevArrow: $(this).find(".btn-slider--prev"),
		nextArrow: $(this).find(".btn-slider--next"),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					vertical: false,
			}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					vertical: false,
			}
			}
		]
	});
});


var galleries = $('.gallery');
galleries.each(function() {
	var gallery = $(this);
	gallery.find('div:not(.slick-cloned)').children('a').magnificPopup({
		type: 'image',
		tLoading: 'Загрузка изображения #%curr%...',
		tClose: 'Закрыть окно (Esc)', 
		mainClass: 'mfp-fade mfp-img-mobile',
		
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '%curr% из %total%',
			tPrev: 'Предыдущий', // Alt text on left arrow
			tNext: 'Следующий',
			
			arrowMarkup: '<div title="%title%" class="gallery__arrow gallery__arrow--%dir% mfp-arrow mfp-arrow-%dir%"></div>',
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		closeMarkup: '<span title="%title%" class="mfp-close popup-gallery__close"></span>',
		image: {
			tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
			titleSrc: function(item) {
				return '';
			}
		}
	});
});

var galleries = $('.articleslider');
galleries.each(function() {
	var gallery = $(this);
	gallery.find('div:not(.slick-cloned)').children('a').magnificPopup({
		type: 'image',
		tLoading: 'Загрузка изображения #%curr%...',
		tClose: 'Закрыть окно (Esc)', 
		mainClass: 'mfp-fade mfp-img-mobile',
		
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '%curr% из %total%',
			tPrev: 'Предыдущий', // Alt text on left arrow
			tNext: 'Следующий',
			
			arrowMarkup: '<div title="%title%" class="gallery__arrow gallery__arrow--%dir% mfp-arrow mfp-arrow-%dir%"></div>',
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		closeMarkup: '<span title="%title%" class="mfp-close popup-gallery__close"></span>',
		image: {
			tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
			titleSrc: function(item) {
				return '';
			}
		}
	});
});



function setCookie(name, value, days) {
	const date = new Date();
	date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	const expires = "expires=" + date.toUTCString();
	document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function eraseCookie(name) {
	setCookie(name, "", -1);
}

function changePhone() {
	let optionSelect = document.querySelectorAll(".cityselect__option");
	let currentCity = document.querySelector("#currentcity");
	let currentPhone = document.querySelector("#cityphone");
    
	optionSelect.forEach((element) => {
	    element.addEventListener('click', function() {
		let elNumber =  element.dataset.number;
		let elTitle =  element.dataset.title;
    
		setCookie('selectedPhone', elNumber, 30); // сохраняем номер телефона в куки на 30 дней
		setCookie('selectedCity', elTitle, 30);   // сохраняем название города в куки на 30 дней
    
		updatePhoneAndCity(elNumber, elTitle);
	    });
	});
    
	// Проверим куки при инициализации
	const savedPhone = getCookie('selectedPhone');
	const savedCity = getCookie('selectedCity');
	if (savedPhone && savedCity) {
	    updatePhoneAndCity(savedPhone, savedCity);
	}
}
    
function updatePhoneAndCity(number, title) {
	let currentCity = document.querySelector("#currentcity");
	let currentPhone = document.querySelector("#cityphone");
	const regExp = /\(|\)|-| /g;
    
	currentCity.textContent = title;
	currentPhone.textContent = number;
	let currentPhoneLink = 'tel:' + number.replace(regExp, '');
    
	let optionSelect = document.querySelectorAll(".cityselect__option");
	for(let i = 0; i < optionSelect.length; i++) {
	    optionSelect[i].classList.remove('is-active');
	    if (optionSelect[i].dataset.number === number && optionSelect[i].dataset.title === title) {
		optionSelect[i].classList.add('is-active');
	    }
	}
    
	currentPhone.href = currentPhoneLink;
	currentPhone.style.visibility = "visible"; // делаем номер видимым
	currentCity.style.visibility = "visible";   // делаем город видимым
    }

changePhone();


$(".btn-cat").click(function() {
	$(this).toggleClass("is-active");
	$(".btn-cat span").text(function(i, text){
		return text === "Закрыть каталог" ? "Каталог товаров" : "Закрыть каталог";
	})
	$(".btn-cat__ico").html(function(i, text){
		return text === '<svg><use xlink:href="assets/build/images/sprites.svg#close"></use></svg>' ? '<svg><use xlink:href="assets/build/images/sprites.svg#menu"></use></svg>' : '<svg><use xlink:href="assets/build/images/sprites.svg#close"></use></svg>';
	})
	$(".catalog-menu").toggleClass("is-open");
});


$(".footer__mobilebtn").click(function() {
	$(this).toggleClass("is-active");
	$(this).parent(".footer__menu").find(".footer__menuwrap").slideToggle();
});

$(".header__searchmobile").click(function() {
	$(this).html(function(i, text){
		return text === '<svg><use xlink:href="assets/build/images/sprites.svg#close"></use></svg>' ? '<svg><use xlink:href="assets/build/images/sprites.svg#search"></use></svg>' : '<svg><use xlink:href="assets/build/images/sprites.svg#close"></use></svg>';
	})
	$(".header__search").slideToggle();
});




$(".category-page__btnfilters").click(function() {
	$(".filters").addClass("is-active");
	$(".filter-overlay").addClass("is-active");
	$(".header__btns").addClass("is-hidden");
	$(".category-page").addClass("filter-open");
});

$(".filter-overlay").click(function() {
	$(".filters").removeClass("is-active");
	$(this).removeClass("is-active");
	$(".header__btns").removeClass("is-hidden");
	$(".category-page").removeClass("filter-open");
});

$(".filters__close").click(function() {
	$(".filters").removeClass("is-active");
	$(".filter-overlay").removeClass("is-active");
	$(".header__btns").removeClass("is-hidden");
	$(".category-page").removeClass("filter-open");
})

$(".product-tabsblock__tabmobiletitle").click(function() {
	$(this).toggleClass("is-active");
	$(this).parent(".product-tabsblock__tabcontent").find(".product-tabsblock__tabwrapper").slideToggle();
});





